import React from "react";
import { Button } from "@mui/material";
import { MdDelete, MdLocationOn, MdEdit } from "react-icons/md";
import { FaCheck } from "react-icons/fa";
import "./style.css";

const AddressCard = ({
  address,
  isSelected,
  onSelect,
  onSetDefault,
  onEdit,
  onDelete,
  setDefaultLoading,
  deleteLoading,
  showActions = true,
}) => {
  const handleSetDefault = () => {
    if (onSetDefault && !address.isDefault) {
      onSetDefault(address.id);
    }
  };

  const handleDelete = () => {
    if (
      onDelete &&
      window.confirm("Are you sure you want to delete this address?")
    ) {
      onDelete(address.id);
    }
  };

  return (
    <div
      className={`address-card ${isSelected ? "selected" : ""} ${
        address.isDefault ? "default" : ""
      }`}
    >
      <div className="address-header">
        <div className="selection-area" onClick={onSelect}>
          <div className={`radio-button ${isSelected ? "selected" : ""}`}>
            {isSelected && <FaCheck size={12} />}
          </div>
          <div className="address-type">
            <MdLocationOn size={18} />
            <span className="type-label">
              {address.addressType.charAt(0).toUpperCase() +
                address.addressType.slice(1)}
            </span>
            {address.isDefault && (
              <span className="default-badge">Default</span>
            )}
          </div>
        </div>

        {showActions && (
          <div className="address-actions">
            {!address.isDefault && (
              <Button
                size="small"
                variant="outlined"
                onClick={handleSetDefault}
                disabled={setDefaultLoading}
                className="set-default-btn"
              >
                {setDefaultLoading ? "Setting..." : "Set as Default"}
              </Button>
            )}

            <Button
              size="small"
              variant="outlined"
              onClick={() => onEdit && onEdit(address)}
              className="edit-btn"
            >
              <MdEdit size={16} />
            </Button>

            <Button
              size="small"
              variant="outlined"
              onClick={handleDelete}
              disabled={deleteLoading}
              className="delete-btn"
            >
              <MdDelete size={16} />
            </Button>
          </div>
        )}
      </div>

      <div className="address-content" onClick={onSelect}>
        <div className="address-name">
          <strong>{address.name}</strong>
          <span className="phone-number">{address.phoneNumber}</span>
        </div>

        <div className="address-email">
          <span className="email-address">{address.email}</span>
        </div>

        <div className="address-details">
          <p className="full-address">
            {address.address}
            {address.landmark && <span>, {address.landmark}</span>}
          </p>
          <p className="city-state">
            {address.city}, {address.state} - {address.pincode}
          </p>
        </div>
      </div>
    </div>
  );
};

export default AddressCard;
